import { Link, Outlet, useLocation } from "react-router";
import { logValue } from "../lib/sheets";
import { NAV, type NavEntry } from "../nav";
import { AppProvider } from "./AppContext";
import { useApp } from "./appState";
import { Icon } from "./Icons";
import { SheetHost } from "./SheetHost";

function isActive(e: NavEntry, pathname: string): boolean {
  const p = pathname.toLowerCase();
  if (e.to === "/") return p === "/";
  // Bands and venues share one tab.
  if (e.icon === "roster") return p.startsWith("/bands") || p.startsWith("/venues");
  return p.startsWith(e.to);
}

function Chrome() {
  const { open } = useApp();
  const { pathname } = useLocation();
  const log = () => open("log", logValue());
  return (
    <div className="app">
      <header className="hdr">
        <Link to="/" className="brand" style={{ color: "inherit", textDecoration: "none" }}>
          Shows<i>.</i>
        </Link>
        <nav className="topnav" aria-label="Pages">
          {NAV.map((e) => (
            <Link key={e.to} to={e.to} aria-current={isActive(e, pathname) ? "page" : undefined}>
              {e.label}
            </Link>
          ))}
        </nav>
        <div className="hdr-r">
          <button type="button" className="btn primary sm logbtn" onClick={log}>
            + Log a show
          </button>
        </div>
      </header>
      <main className="page">
        <Outlet />
      </main>
      {pathname === "/" && (
        <button type="button" className="fab" onClick={log}>
          + Log a show
        </button>
      )}
      <nav className="botnav" aria-label="Tabs">
        {NAV.map((e) => (
          <Link key={e.to} to={e.to} aria-current={isActive(e, pathname) ? "page" : undefined}>
            <Icon name={e.icon} />
            <span>{e.label}</span>
          </Link>
        ))}
      </nav>
      <SheetHost />
    </div>
  );
}

/** Chrome around every signed-in page. `react-router`, never `react-router-dom` (eslint enforces it). */
export function Layout({ email, onSignOut }: { email: string | null; onSignOut: () => void }) {
  return (
    <AppProvider email={email} onSignOut={onSignOut}>
      <Chrome />
    </AppProvider>
  );
}
